import { api } from "./api";

const SESSION_KEY = "gaole_market_listing_impressions";
const pending = new Set<string>();
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function sessionSeen(): Set<string> {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

function markSeen(ids: string[]) {
  const seen = sessionSeen();
  for (const id of ids) seen.add(id);
  sessionStorage.setItem(SESSION_KEY, JSON.stringify([...seen].slice(-500)));
}

function scheduleFlush(kind: "LISTING" | "DETAIL") {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    const batch = [...pending];
    pending.clear();
    if (!batch.length) return;
    void api("/marketplace/impressions", { method: "POST", body: { listingIds: batch, kind } }).catch(() => {});
  }, 800);
}

export function trackMarketplaceListingImpression(listingId: string, kind: "LISTING" | "DETAIL" = "LISTING") {
  if (!listingId) return;
  const key = `${kind}:${listingId}`;
  const seen = sessionSeen();
  if (seen.has(key)) return;
  markSeen([key]);
  if (kind === "DETAIL") {
    void api("/marketplace/impressions", { method: "POST", body: { listingIds: [listingId], kind: "DETAIL" } }).catch(
      () => {},
    );
    return;
  }
  pending.add(listingId);
  scheduleFlush("LISTING");
}
